import * as css from '../eventSettings/paymentForm/PaymentForm.css';
import SubSettingItem from './subSettingItem/SubSettingItem';
import Input from '../../component/input/Input';
import ModeBtn from '../../component/modeBtn/ModeBtn';
import Button from '../../component/button/button/Button';
import InputList from '../../component/input/inputList/InputList';
import InputAmount from '../../component/input/inputAmount/InputAmount';
import DataItems from '../../component/dataItems/DataItems';
import {updateEventSettings} from '../../redux/event/eventActions';
import store from '../../store';

export const createSettingInputs = (settings, category, settingsXHR, t) => {
    const update = (name, setting) => {
        if(settings?.[name] !== setting)
            updateEventSettings(name, setting, category);
    };

    return {
        getInput: (name, label) =>
            <SubSettingItem text={label || t(`${name}`)}>
                <css.input>
                    <Input
                        name={name}
                        events={{onBlur: update}}
                        className={settingsXHR?.[`${name}XHR`]}
                    />
                </css.input>
            </SubSettingItem>,
        getAmountInput: (name, text, amountText) =>
            <SubSettingItem text={text || t(`${name}`)}>
                <css.input>
                    <InputAmount
                        name={name}
                        events={{onBlur: update}}
                        className={settingsXHR?.[`${name}XHR`]}
                        amountText={amountText || store.getState().event.currencySymbol}
                    />
                </css.input>
            </SubSettingItem>,
        getToggle: (name,  onClick = null) =>
            <SubSettingItem text={t(`${name}`)}>
                <ModeBtn
                    click={onClick ? () => onClick(name, settings, !settings[name]) : () => update(name, !settings?.[name])}
                    status={settings?.[name]}
                    requestStatus={settingsXHR?.[`${name}XHR`]}
                    dataCyName={name}
                />
            </SubSettingItem>,
        getButton: (text, onClick, width = 70, height = '20px') =>
            <SubSettingItem text={text}>
                <Button
                    BtnProps={{
                        text: t('edit'),
                        onClick: onClick,
                        width: width,
                        height: height
                    }}
                />
            </SubSettingItem>,
        getList: (name, list, onClick = update,isFixed=false) =>
            <SubSettingItem text={ t(`${name}`)}>
                <css.input>
                    <InputList
                        name={name}
                        list={list}
                        onChange={(name, key) => onClick(name, key, settings)}
                        className={settingsXHR?.[`${name}XHR`]}
                        t={t}
                        width={isFixed?'160px':'100%'}
                        listProps={{isFixed}}
                    />
                </css.input>
            </SubSettingItem>,
        getDataItems: (name, list, label, onClick = update, maxToShow = 2, listText, icon, listWidth = '100%') =>
            <SubSettingItem text={label || t(`${name}`)}>
                <css.input>
                    <DataItems
                        isFixedTop={true}
                        list={list}
                        onChange={(item, action) => {
                            if(action === 'add') {
                                onClick(name, item.key, settings);
                            } else if(action === 'remove') {
                                onClick(name, item.key, settings);
                            }
                        }}
                        className={settingsXHR?.[`${name}XHR`]}
                        maxToShow={maxToShow}
                        listText={listText}
                        icon={icon}
                        listWidth={listWidth}
                    />
                </css.input>
            </SubSettingItem>
    };
};
